// Local translations
export const T = {
  en_GB: {
    maxGoalsReached: "Maximum Goals Reached",
    maxGoalsDescription: (max: number) => `You can have a maximum of ${max} goals.`,
    error: "Error",
    failedToCreateGoal: "Failed to create goal",
    cannotDeleteLastGoal: "Cannot Delete Last Goal",
    cannotDeleteLastGoalDescription:
      "You must have at least one goal. Please create another goal before deleting this one.",
    goalDeletedSuccessfully: "Goal deleted successfully",
    failedToDeleteGoal: "Failed to delete goal",
    deleteGoal: "Delete Goal",
    deleteGoalDescription:
      "Are you sure you want to delete this goal? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
  },
  nb_NO: {
    maxGoalsReached: "Maksimalt antall mål nådd",
    maxGoalsDescription: (max: number) => `Du kan ha maksimalt ${max} mål.`,
    error: "Feil",
    failedToCreateGoal: "Kunne ikke opprette mål",
    cannotDeleteLastGoal: "Kan ikke slette siste mål",
    cannotDeleteLastGoalDescription:
      "Du må ha minst ett mål. Opprett et nytt mål før du sletter dette.",
    goalDeletedSuccessfully: "Mål slettet",
    failedToDeleteGoal: "Kunne ikke slette mål",
    deleteGoal: "Slett mål",
    deleteGoalDescription:
      "Er du sikker på at du vil slette dette målet? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
  },
} as const;
